import script from "./PageHeadingText.vue?vue&type=script&setup=true&lang=js"
export * from "./PageHeadingText.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__